/*
 * Copyright (C) 2022 SADE Innovations Oy - All Rights Reserved
 *
 * NOTICE: This software is owned by SADE Innovations Oy and licensed under SADE Booster license.
 * All dissemination, usage, modification, copying, reproduction, selling and distribution of the
 * software and its intellectual and technical concepts are strictly forbidden without a valid license.
 * Such license can be obtained by issuing a SADE Booster License agreement from SADE Innovations Oy
 * (https://sadeinnovations.com).
 */
import { ReferenceHW } from "../ReferenceHW/ReferenceHW";
import { HyperHWState } from "./HyperHWState";
import { HyperHWStateProperties } from "./HyperHWStateProperties";
import { router24Px } from "../../generated/SadeDataIconModel";
export class HyperHW extends ReferenceHW {
    constructor(backend, params) {
        super(HyperHW.type, backend, params);
    }
    static instanceOf(device) {
        return device instanceof HyperHW;
    }
    getIcon() {
        return router24Px.data;
    }
    createState(timestamp, version, reported, desired, connectionState) {
        return new HyperHWState(this.getId(), new HyperHWStateProperties(reported !== null && reported !== void 0 ? reported : {}), new HyperHWStateProperties(desired !== null && desired !== void 0 ? desired : {}), timestamp, version, connectionState);
    }
}
HyperHW.type = "Hyper";
